import { addTracking as y } from "@sunrise/tracking";
import { defineComponent as m, getCurrentInstance as h, computed as a } from "vue";
import S from "./index12.js";
const p = m({
  name: "CsPrimaryButton",
  components: {
    CsButtonLoadingSpinner: S
  },
  props: {
    isDisabled: {
      type: Boolean,
      defaultValue: !1
    },
    isSmall: {
      type: Boolean,
      defaultValue: !1
    },
    isLoading: {
      type: Boolean,
      defaultValue: !1
    },
    isCentered: {
      default: !1,
      type: Boolean
    },
    hasClickArea: {
      default: !1,
      type: Boolean
    },
    target: {
      default: "_self",
      type: String
    },
    href: {
      default: "",
      type: String
    },
    rel: {
      default: void 0,
      type: String
    },
    ariaLabel: String,
    type: {
      default: "button",
      type: String
    },
    trackingData: Array
  },
  setup(e) {
    var i;
    const t = (i = h()) == null ? void 0 : i.proxy, l = a(() => !!e.href), r = a(() => {
      var n;
      return l.value && ((n = e.href) == null ? void 0 : n.length) > 0 ? e.href : null;
    }), u = a(() => {
      var n;
      return l.value && e.rel && ((n = e.rel) == null ? void 0 : n.length) > 0 ? e.rel : null;
    }), f = a(() => l.value ? e.target : void 0), g = a(() => l.value ? null : e.type), s = a(() => l.value ? "a" : "button");
    let o;
    e.trackingData && (o = y(e.trackingData));
    function d() {
      return !!(t != null && t.$slots.default);
    }
    function c() {
      return !!(t != null && t.$slots.icon);
    }
    return {
      getHref: r,
      getRel: u,
      getTag: s,
      getTarget: f,
      getType: g,
      hasDefaultSlot: d,
      hasIconSlot: c,
      tracking: o
    };
  }
});
export {
  p as default
};
